export default "__VITE_ASSET__CPYrWiTN__"